import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent'; 
import CloseIcon from '../../assets/images/close-icon.svg';
import ProjectFilters from '../ProjectFilters';
import Button from '../Buttons/DialogButton';
import Animate from '../../components/Animate';
import dataModel from '../../models/DataModel';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import './ProjectFilterPopout.scss';

export class ProjectFilterPopout extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataChanged: false,
      selectedProjectType: props.selectedFilters && props.selectedFilters.project_type ? props.selectedFilters.project_type :null,
      selectedState: props.selectedFilters && props.selectedFilters.state ? props.selectedFilters.state : null,
      selectedStatuses: props.selectedFilters && props.selectedFilters.statuses ? props.selectedFilters.statuses : null,
      selectedMarkets: props.selectedFilters && props.selectedFilters.markets ? props.selectedFilters.markets : null,
      archiveSelected: props.selectedFilters && props.selectedFilters.showArchived,
    };

    const currentRole = dataModel.usersDAO.currentUser ? dataModel.usersDAO.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentWillUnmount(){
    if(this.state.dataCleared){
      this.setState({
        dataCleared: false,
      });
    }
  }

  handleProjectTypeSelection(project_type) {
    this.setState({
      selectedProjectType: project_type,
      dataChanged: true,
      dataCleared: false,
    });
  }

  handleStateSelection(state) {
    this.setState({
      selectedState: state,
      dataChanged: true,
      dataCleared: false,
    });
  }

  handleMarketSelection(markets){
    this.setState({
      selectedMarkets: markets,
      dataChanged: true,
      dataCleared: false,
    });
  }

  handleStatusSelection(statuses) {
    this.setState({ 
      selectedStatuses: statuses,
      dataChanged: true,
      dataCleared: false,
    });
  }

  handleArchiveSelection(checked) {
    this.setState({ 
      archiveSelected: checked,
      dataChanged: true,
      dataCleared: false,
    });
  }

  handleApplyFilter() {
    const { selectedProjectType, selectedState, selectedStatuses, archiveSelected, selectedMarkets } = this.state;
    let filter = {};
    
    this.handleCancel();
    
    if (selectedProjectType && selectedProjectType.id) {
      filter.project_type = selectedProjectType;
    }

    if (selectedState) {
      filter.state = selectedState;
    }

    if (selectedStatuses) {
      filter.statuses = selectedStatuses;
    }

    if (selectedMarkets) {
      filter.markets = selectedMarkets;
    }

    filter.showArchived = archiveSelected;
    
    if (this.props.handleApplyFilter) {
      this.props.handleApplyFilter(filter);
    }
    if (selectedProjectType || selectedState || selectedStatuses || archiveSelected) {
      this.analyticsLogger.logProjectListFilteringEvent();
    }
  }

  handleCancel() {
    this.setState({ 
      animateClose: true,
      dataChanged: false,
      dataCleared: false, 
    });
  }
    
  handleClear() {
    this.props.handleClear();
    this.setState({
      selectedProjectType: null,
      selectedState: null,
      selectedMarkets: null,
      selectedStatuses: null,
      archiveSelected: false,
      dataChanged: false,
      dataCleared: true,
    });
  }

  handleAnimationDone() {
    this.props.handleCancel();
  }

  render() {

    const { left, top, isMarketFilterEnabled } = this.props;

    let style = {
      left: left,
      top: top,
      height: isMarketFilterEnabled ? '400px' : '314px',
    };

    const buttonStyle = {
      marginTop: isMarketFilterEnabled ? '165px' : '85px',
    };
    
    return (
      <div id="outer-popout-container"  className="outer-popout-container" style={style}>
        <Animate 
          key="outer-popout-container-in" 
          component_id="outer-popout-container" 
          duration={150} 
          property={{
            width: {
              startVal: 0,
              endVal: 285,
            } }
          } 
        />
        {
          this.state.animateClose && (
            <Animate 
              key="outer-popout-container-out" 
              component_id="outer-popout-container" 
              duration={150} 
              property={{
                width: {
                  startVal: 285,
                  endVal: 0,
                },
              }} 
              completionCallback={this.handleAnimationDone} 
            />
          )
        }
      <div className="popout-container">
        <div className="arrow-left"/> 
        <div className='popout-header'>
            <div className='popout-title'>{this.textMap.filterProject}</div>
            <img className='popout-close-icon' src={CloseIcon} alt='close' onClick={this.handleCancel}/>
        </div>
        <div className='popout-filter-container'>
          <ProjectFilters 
            handleProjectTypeSelection={this.handleProjectTypeSelection}
            handleStateSelection={this.handleStateSelection} 
            handleMarketSelection={this.handleMarketSelection}
            handleStatusSelection={this.handleStatusSelection}
            selectedFilters={this.props.selectedFilters}
            handleArchiveSelection={this.handleArchiveSelection} 
            showArchived={this.state.archiveSelected} 
            archivedDisabled={this.props.archivedDisabled}
            isMarketFilterEnabled={isMarketFilterEnabled}
            isDataCleared={this.state.dataCleared}
          />
        </div>

        <div className='button-container' style={buttonStyle}>
        <Button
          width={40}
          height={32}
          text={this.textMap.clear.toUpperCase()}
          position="absolute"
          bottom={19}
          left={24}
          fontStyle={{
            color: '#9b9b9b',
            fontFamily: 'Open Sans',
            fontSize: '12px',
            letterSpacing: '0px',
            lineHeight: '32px',
          }}
          fill="#ffffff"
          handleClick={this.handleClear}
        />

          { this.state.dataChanged ? 

            <Button             
              width={60}
              height={32}
              text={this.textMap.apply.toUpperCase()}
              position="absolute"
              bottom={19}
              left={137}
              fontStyle={{
                color: '#ffffff',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                letterSpacing: '0px',
                lineHeight: '32px',
              }}
              fill="#5db348"
              handleClick={this.handleApplyFilter}
            /> :
            <Button
              width={60}
              height={30}
              text={this.textMap.apply.toUpperCase()}
              position="absolute"
              bottom={19}
              left={137}
              disabled={true}
              border={'solid 1px #5db348'}
              fontStyle={{
                color: '#5db348',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                letterSpacing: '0px',
                lineHeight: '32px',
              }}
              fill="#ffffff"
            />
          }

        </div>
    </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps, null)(ProjectFilterPopout);



// WEBPACK FOOTER //
// ./src/components/ProjectFilterPopout/index.js